// @ts-ignore
import { FullWidthImage, Header, Hero, PageFooter, PageHeader } from '@telia/styleguide';
// @ts-ignore
import AllIcons from '@telia/styleguide/assets/allicons/AllIcons';
import { graphql, StaticQuery } from 'gatsby';
import React from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import theme from '../../config/Theme';
import './layout.scss';
const GlobalStyle = createGlobalStyle`
  ::selection {
    color: ${theme.colors.bg};
    background: ${theme.colors.primary};
  }
  body {
    background: ${theme.colors.bg};
    color: ${theme.colors.grey.default};
    font-size: 14px;
  }
  a {
    color: ${theme.colors.grey.dark};
    text-decoration: none;
    transition: all ${theme.transitions.normal};
  }
  a:hover {
    color: ${theme.colors.primary};
  }
  h1, h2, h3, h4 {
    color: ${theme.colors.grey.dark};
  }
  blockquote {
    font-style: italic;
    position: relative;
  }

  blockquote:before {
    content: "";
    position: absolute;
    background: ${theme.colors.primary};
    height: 100%;
    width: 6px;
    margin-left: -1.6rem;
  }
  label {
    margin-bottom: .5rem;
    color: ${theme.colors.grey.dark};
  }
  input, textarea {
    border-radius: .5rem;
    border: none;
    background: rgba(0, 0, 0, 0.05);
    padding: .25rem 1rem;
    &:focus {
      outline: none;
    }
  }
`;

const links = [
  { text: 'Open Source', url: '/open-source' },
  { text: 'Blog', url: '/blog' },
  // { text: 'Books', url: '/books' },
  // { text: 'Events', url: '/events' },
  { text: 'Careers', url: 'https://www.teliacompany.com/en/careers/' },
];

const menuLinks = [
  {
    heading: 'Telia Engineering',
    loggedOutLinks: links,
  },
];

const specialLink = { text: 'Personvern og Cookies', url: '#' };

export class Layout extends React.PureComponent<{}> {
  public render() {
    const { children } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query LayoutQuery {
            site {
              buildTime(formatString: "DD.MM.YYYY")
            }
          }
        `}
        render={() => (
          <ThemeProvider theme={theme}>
            <React.Fragment>
              <AllIcons />
              <GlobalStyle />
              <PageHeader
                menuId='page-header-menu--example-1'
                logoUrl='/'
                logoTitle='Telia logo'
                logoImageDesktopPath='/images/logo.svg'
                logoImageDesktopPathInverted='/images/logo-inverted.svg'
                cartItemCount={0}
                menuLinks={menuLinks}
              />
              {children}
              <br />
              <PageFooter links={links} specialLink={specialLink} />
            </React.Fragment>
          </ThemeProvider>
        )}
      />
    );
  }
}
